import { useState, useCallback } from "react";
const useInput = (initialValue) => {
  const [value, setValue] = useState(initialValue);
  const onChange = useCallback((e) => setValue(e && e.target ? e.target.value : e), []);
  return {
    value,
    onChange
  };
};
export {
  useInput as default
};
//# sourceMappingURL=useInput.es.js.map
